<ng-template [ngIf]="!infinity || !deviceService.isMobile()" [ngIfElse]="infinityCard">
  <ng-template [ngIf]="format !== 'card-micro'" [ngIfElse]="micro">
    <article class="content-card-mini"
             [class.mid]="format === 'card-mid'"
             [class.active]="active"
             itemscope
             itemtype="https://schema.org/Article">

      <ng-container *ngTemplateOutlet="meta"></ng-container>

      <div *ngIf="!linkEnable && isBrowser" class="card-cover"></div>

      <div class="container">
        <ng-container *ngTemplateOutlet="authorInfo"></ng-container>

        <div class="cover-wrap">
          <on-ui-cover [cover]="cover" [attr.data-test]="'coverImg'"></on-ui-cover>
        </div>

        <ng-container *ngTemplateOutlet="metaLink"></ng-container>

        <ng-container *ngTemplateOutlet="statsTemplate"></ng-container>
      </div>
    </article>
  </ng-template>

  <ng-template #micro>
    <article class="lesson-card-micro"
             itemscope
             itemtype="https://schema.org/Article">

      <ng-container *ngTemplateOutlet="meta"></ng-container>

      <div *ngIf="!linkEnable && isBrowser" class="card-cover"></div>

      <div class="cover-wrap">
        <on-ui-cover [cover]="cover" [attr.data-test]="'coverImg'"></on-ui-cover>
      </div>

      <div class="meta">
        <ng-container *ngTemplateOutlet="authorInfo"></ng-container>

        <a class="meta-link" [routerLink]="contentRoute(item)"
           [attr.data-test]="'lesson_card_micro_lesson_info'"
           [attr.title]="fullTitle">
          <div class="subject-wrap">
            <span class="subject" [attr.data-test]="'lesson_card_micro_subject'">{{ subject }}</span>
            <ng-template [ngIf]="item?.subject?.category_id === subjectCategoryEnum.native_language">
              <span class="subject-category">{{ 'content-mini-card.native' | translate }}</span>
            </ng-template>
          </div>
          <span class="title" [attr.data-test]="'lesson_card_micro_title'">{{ item.title }}</span>
          <span *ngIf="item?.sub_title?.length" class="subtitle"
                [attr.data-test]="'lesson_card_micro_subtitle'">{{ item.sub_title }}</span>
          <span class="content-type-and-level"
                [attr.data-test]="'lesson_card_micro_content_type'">{{ (contentTypeTitle | translate) + ', ' + (level | translate) | cutText: cutLength }}</span>
        </a>

        <ng-container *ngTemplateOutlet="statsTemplate"></ng-container>
      </div>
    </article>
  </ng-template>
</ng-template>

<ng-template #infinityCard>
  <article class="lesson-card-mini-infinity"
           itemscope
           itemtype="https://schema.org/Article">

    <ng-container *ngTemplateOutlet="meta"></ng-container>

    <div *ngIf="!linkEnable && isBrowser" class="card-cover"></div>

    <div class="meta">
      <div *ngIf="hasCoverImage" class="cover-wrap">
        <div *ngIf="isMediaTypeNecessary" class="type-content">
          <app-icon class="type-img-ico" [ngClass]="contentTypeUrl" [icon]="'type-' + contentTypeUrl"></app-icon>
        </div>
        <on-ui-cover [cover]="cover" [attr.data-test]="'coverImg'"></on-ui-cover>
      </div>
      <ng-container *ngTemplateOutlet="metaLink"></ng-container>
    </div>

    <p class="description" *ngIf="description">
      {{ description | cutText : 120 }}
      <ng-template [ngIf]="description.length > 120">
        <span class="read-more">{{ 'library.read-more' | translate }}</span>
      </ng-template>
    </p>

    <app-author-info [user]="author"></app-author-info>

    <ng-container *ngTemplateOutlet="statsTemplate"></ng-container>
  </article>
</ng-template>

<ng-template #meta>
  <meta itemscope itemprop="mainEntityOfPage" itemType="https://schema.org/WebPage" [attr.itemid]="contentUrl"/>

  <meta itemprop="url" content="{{ contentUrl }}"/>
  <meta itemprop="name" content="{{ fullTitle }}"/>
  <meta itemprop="datePublished" content="{{ contentDate?.toISOString() }}"/>
  <meta itemprop="image" content="{{ metaImageUrl || coverImageUrl }}"/>
  <!-- <meta *ngIf="description" itemprop="description" content="{{ description | striptags }}"/> -->
  <meta itemprop="headline" content=""/>
  <!-- <meta itemprop="publisher" content="htts://onclass.com"/> -->
  <!-- keywords -->
  <meta itemprop="inLanguage" content="{{ item.language?.code }}"/>
  <!-- discussionUrl -->
  <meta *ngIf="item.stats" itemprop="commentCount" content="{{ item.stats.comments_count }}"/>
</ng-template>

<ng-template #authorInfo>
  <div class="author">
    <div class="author-avatar-wrap">
      <on-ui-cover [cover]="authorAvatar" [attr.data-test]="'authorPhoto'"></on-ui-cover>
    </div>
    <div class="author-info">
      <a *ngIf="author" [routerLink]="accountRoute(author)"
         class="author-name"
         [attr.data-test]="'lesson_card_author_name'"
         [attr.title]="authorFullName">
        <span>{{ authorName }}</span>
      </a>
    </div>
    <span *ngIf="!author">&nbsp;</span>
  </div>
</ng-template>

<ng-template #metaLink>
  <a class="meta-link" [routerLink]="contentRoute(item)"
     [attr.data-test]="'lesson_card_info'"
     [attr.title]="fullTitle">
    <div class="subject-wrap">
      <span class="subject" [attr.data-test]="'lesson_card_subject'">{{ subject }}</span>
      <ng-template [ngIf]="item?.subject?.category_id === subjectCategoryEnum.native_language">
        <span class="subject-category">{{ 'content-mini-card.native' | translate }}</span>
      </ng-template>
    </div>
    <span class="title" [attr.data-test]="'lesson_card_title'">{{ item.title }}</span>
    <span *ngIf="item?.sub_title?.length" class="subtitle"
          [attr.data-test]="'lesson_card_subtitle'">{{ item.sub_title }}</span>
    <span class="content-type-and-level" [attr.data-test]="'lesson_card_content_type'">
      {{ (contentTypeTitle | translate) + ', ' + (level | translate) }}
    </span>
  </a>
</ng-template>

<ng-template #statsTemplate>
  <div class="details">
    <div class="details-left">
      <div class="item">
        <app-icon class="likes-icon" [class.active]="item.visit_info && item.visit_info.is_liked" icon="thumb-up"></app-icon>
        <span [attr.data-test]="'lesson_card_likes'">{{ item.stats.likes_count }}</span>
      </div>

      <div class="item">
        <app-icon class="dislikes-icon" [class.active]="item.visit_info && item.visit_info.is_disliked" icon="thumb-down"></app-icon>
        <span [attr.data-test]="'lesson_card_dislikes'">{{ item.stats.dislikes_count }}</span>
      </div>
    </div>
    <div class="details-right">
      <div class="item">
        <app-icon class="views-icon" [class.active]="item.visit_info && item.visit_info.is_viewed" icon="shows"></app-icon>
        <span [attr.data-test]="'lesson_card_views'">{{ item.stats.views_count }}</span>
      </div>
    </div>
  </div>
</ng-template>
